/**
 * Informações da marca em um só lugar.
 * ⚠️ Telefone/WhatsApp/e-mail ainda são os placeholders que já existiam no projeto.
 */
export const SITE = {
  name: "Ninja Burger",
  tagline: "O hambúrguer que ataca sua fome nas sombras da noite.",
  address: {
    street: "Rua dos Ninjas, 123",
    city: "Guarulhos, SP",
    label: "Centro Operacional",
  },
  phone: "(11) 99999-9999",
  whatsappNumber: "5511999999999",
  email: "contato@ninjaburger.com.br",
  hours: [
    { days: "Ter a Qui", time: "18h — 23h" },
    { days: "Sex a Dom", time: "18h — 00h" },
    { days: "Segunda", time: "Fechado" },
  ],
  mapEmbedUrl:
    "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d58543.08581678853!2d-46.564531851367175!3d-23.417431199999993!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94ce8a8d79361685%3A0xc608d4d849480119!2sGuarulhos%20-%20SP!5e0!3m2!1spt-BR!2sbr!4v1710500000000!5m2!1spt-BR!2sbr",
  /** URL de vídeo (YouTube embed ou .mp4). Vazio = botão "Ver vídeo" fica oculto. */
  heroVideoUrl: "",
  /**
   * Cupom exibido no banner. A validação e o desconto acontecem no backend
   * (config/coupons.js) — mantenha os dois em sincronia.
   */
  promo: {
    enabled: true,
    discount: "20% OFF",
    description: "no primeiro pedido",
    code: "NINJA20",
  },
} as const;

export const whatsappLink = (message?: string) =>
  `https://wa.me/${SITE.whatsappNumber}${message ? `?text=${encodeURIComponent(message)}` : ""}`;

export interface NavLink {
  label: string;
  /** Rota do react-router (pode conter hash para seções da Home). */
  to: string;
  /** id da seção na Home usada no destaque do link ativo. */
  sectionId?: string;
}

export const NAV_LINKS: NavLink[] = [
  { label: "Home", to: "/", sectionId: "Hero" },
  { label: "Cardápio", to: "/cardapio" },
  { label: "Sobre", to: "/#Sobre", sectionId: "Sobre" },
  { label: "Como Pedir", to: "/#comoPedir", sectionId: "comoPedir" },
  { label: "Galeria", to: "/#galeria", sectionId: "galeria" },
  { label: "Contato", to: "/#contato", sectionId: "contato" },
];
